import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DetalheAtlasPage } from './detalhe-atlas';
import { IonicImageViewerModule } from 'ionic-img-viewer';

@NgModule({
  declarations: [
    DetalheAtlasPage
  ],
  imports: [
    IonicPageModule.forChild(DetalheAtlasPage),
    IonicImageViewerModule
  ],
})
export class DetalheAtlasPageModule { }



// WEBPACK FOOTER //
// ./src/pages/detalhe-atlas/detalhe-atlas.module.ts